var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dui-explicit-content space-bottom-none"},[_vm._v("\n  Explicit\n")])}
var staticRenderFns = []

export { render, staticRenderFns }